import { RootState } from 'app/store';

export const selectTourState = (state: RootState) => state.tour;
export const selectTourIsRunning = (state: RootState) => state.tour.run;
export const selectTourSteps = (state: RootState) => state.tour.steps;

